import $ from 'jquery';

const VARIANT_MAKER_ID = '1';

document.addEventListener('turbolinks:load', function() {
  const makerSelect = document.querySelector('select[name="q[maker_id_eq]"]');
  const variantSearchField = document.getElementById('variant-maker-search-field');

  if (makerSelect && variantSearchField) {
    // メーカー選択時の処理
    $(makerSelect).on('select2:select', function(e) {
      if (this.value === VARIANT_MAKER_ID) {
        variantSearchField.style.display = 'block';
      } else {
        variantSearchField.style.display = 'none';
      }
    });

    // 初期表示時の制御
    if (makerSelect.value === VARIANT_MAKER_ID) {
      variantSearchField.style.display = 'block';
    }
  }
});
